import type { KidsPolicyItem } from "@/lib/gql/__generated__/graphql";
import { KidsPolicyType } from "@/lib/gql/__generated__/graphql";

import type { KidsPolicyItemZodSchemaType } from "../../validation-schema/validation-schema";

export const kidsPolicyItemConverter = (item: KidsPolicyItem): KidsPolicyItemZodSchemaType => {
	switch (item.kidsDiscountType) {
		case KidsPolicyType.Static:
			return {
				kidsDiscountType: KidsPolicyType.Static,
				kidsMaxAge: item.kidsMaxAge,
				static: item.static!,
				ratio: undefined,
			};

		case KidsPolicyType.NotAvailable:
			return {
				kidsDiscountType: KidsPolicyType.NotAvailable,
				kidsMaxAge: item.kidsMaxAge,
				static: undefined,
				ratio: undefined,
			};

		case KidsPolicyType.Ratio:
			return {
				kidsDiscountType: KidsPolicyType.Ratio,
				kidsMaxAge: item.kidsMaxAge,
				static: undefined,
				ratio: item.ratio,
			};

		default:
			throw new Error("Invalid kids discount type " + item.kidsDiscountType);
	}
};
